export enum ActionType {

    //
    LOG_OUT = 'LOG_OUT',
    RESET_FLYER_STATE = 'RESET_FLYER_STATE',

    //
    LOGIN_START = 'LOGIN_START',
    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGIN_ERROR = 'LOGIN_ERROR',
    LOGIN_COMPLETED = 'LOGIN_COMPLETED',

    REGISTER_START = 'REGISTER_START',
    REGISTER_SUCCESS = 'REGISTER_SUCCESS',
    REGISTER_ERROR = 'REGISTER_ERROR',
    REGISTER_COMPLETED = 'REGISTER_COMPLETED',

    FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START',
    FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR',
    FORGOT_PASSWORD_COMPLETED = 'FORGOT_PASSWORD_COMPLETED',

    RESET_PASSWORD_START = 'RESET_PASSWORD_START',
    RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR',
    RESET_PASSWORD_COMPLETED = 'RESET_PASSWORD_COMPLETED',

    FETCH_USER_DATA_START = 'FETCH_USER_DATA_START',
    FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS',
    FETCH_USER_DATA_ERROR = 'FETCH_USER_DATA_ERROR',
    FETCH_USER_DATA_COMPLETED = 'FETCH_USER_DATA_COMPLETED',

    CONFIRM_EMAIL_START = 'CONFIRM_EMAIL_START',
    CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS',
    CONFIRM_EMAIL_ERROR = 'CONFIRM_EMAIL_ERROR',
    CONFIRM_EMAIL_COMPLETED = 'CONFIRM_EMAIL_COMPLETED',


    // fetching flyers list
    GET_FLYERS_START = 'GET_FLYERS_START',
    GET_FLYERS_SUCCESS = 'GET_FLYERS_SUCCESS',
    GET_FLYERS_ERROR = 'GET_FLYERS_ERROR',
    GET_FLYERS_COMPLETED = 'GET_FLYERS_COMPLETED',

    //getConversationUrlSetting
    GET_CONVERSION_URL_START = 'GET_CONVERSION_URL_START',
    GET_CONVERSION_URL_SUCCESS = 'GET_CONVERSION_URL_SUCCESS',
    GET_CONVERSION_URL_ERROR = 'GET_CONVERSION_URL_ERROR',
    GET_CONVERSION_URL_COMPLETED = 'GET_CONVERSION_URL_COMPLETED',

    //postConversationUrlSetting
    POST_CONVERSION_URL_START = 'POST_CONVERSION_URL_START',
    POST_CONVERSION_URL_SUCCESS = 'POST_CONVERSION_URL_SUCCESS',
    POST_CONVERSION_URL_ERROR = 'POST_CONVERSION_URL_ERROR',
    POST_CONVERSION_URL_COMPLETED = 'POST_CONVERSION_URL_COMPLETED',


    SET_SALE_TYPES_FOR_ALL_FLYERS = 'SET_SALE_TYPES_FOR_ALL_FLYERS',
    GET_SALE_TYPES_FOR_ALL_FLYERS = 'GET_SALE_TYPES_FOR_ALL_FLYERS',

    SET_STORE_SHELF_STYLES = 'SET_STORE_SHELF_STYLES',

    SET_SALE_UNITS_FOR_ALL_FLYERS = 'SET_SALE_UNITS_FOR_ALL_FLYERS',
    SET_SALE_UNITS_FOR_FLYER = 'SET_SALE_UNITS_FOR_FLYER',

    SET_SALE_TYPES_FOR_SPECIFIC_FLYER = 'SET_SALE_TYPES_FOR_SPECIFIC_FLYER',
    GET_SALE_TYPES_FOR_SPECIFIC_FLYER = 'GET_SALE_TYPES_FOR_SPECIFIC_FLYER',

    CHANGE_FLYERS_STATE = 'CHANGE_FLYERS_STATE',

    //flyers actions
    SOFT_DELETE_FLYER = 'SOFT_DELETE_FLYER',
    SOFT_DELETE_FLYER_SUCCESS = 'SOFT_DELETE_FLYER_SUCCESS',
    SOFT_DELETE_FLYER_ERROR = 'SOFT_DELETE_FLYER_ERROR',

    UPDATE_SALE_TYPES_FOR_ACCOUNT_START = 'UPDATE_SALE_TYPES_FOR_ACCOUNT_START',
    UPDATE_SALE_TYPES_FOR_ACCOUNT_SUCCESS = 'UPDATE_SALE_TYPES_FOR_ACCOUNT_SUCCESS',
    UPDATE_SALE_TYPES_FOR_ACCOUNT_ERROR = 'UPDATE_SALE_TYPES_FOR_ACCOUNT_ERROR',
    UPDATE_SALE_TYPES_FOR_ACCOUNT_COMPLETE = 'UPDATE_SALE_TYPES_FOR_ACCOUNT_COMPLETE',


    HARD_DELETE_FLYER = 'HARD_DELETE_FLYER',
    HARD_DELETE_FLYER_SUCCESS = 'HARD_DELETE_FLYER_SUCCESS',
    HARD_DELETE_FLYER_ERROR = 'HARD_DELETE_FLYER_ERROR',

    ARCHIVE_FLYER = 'ARCHIVE_FLYER',
    ARCHIVE_FLYER_SUCCESS = 'ARCHIVE_FLYER_SUCCESS',
    ARCHIVE_FLYER_ERROR = 'ARCHIVE_FLYER_ERROR',

    SET_DEFAULT_STATE_FLYERS = "SET_DEFAULT_STATE_FLYERS",

    FLYER_DETAILS_DATA_CHANGE_EVENT = 'FLYER_DETAILS_DATA_CHANGE_EVENT',
    FLYER_DETAILS_SET_IMAGE_TO_TARGET_PAGE = 'FLYER_DETAILS_SET_IMAGE_TO_TARGET_PAGE',

    //
    FLYER_DETAILS_ANY_DATA_WAS_CHANGED = 'FLYER_DETAILS_ANY_DATA_WAS_CHANGED',


    // flipping flyer
    GET_FLIPPING_FLYER_START = 'GET_FLIPPING_FLYER_START',
    GET_FLIPPING_FLYER_SUCCESS = 'GET_FLIPPING_FLYER_SUCCESS',
    GET_FLIPPING_FLYER_ERROR = 'GET_FLIPPING_FLYER_ERROR',
    GET_FLIPPING_FLYER_COMPLETED = 'GET_FLIPPING_FLYER_COMPLETED',

    CLEAR_DATA_FROM_FLYER = 'CLEAR_DATA_FROM_FLYER',

    FLIPPING_FLYER_DATA_CHANGE_EVENT = 'FLIPPING_FLYER_DATA_CHANGE_EVENT',

    POST_FLIPPING_FLYER_START = 'POST_FLIPPING_FLYER_START',
    POST_FLIPPING_FLYER_SUCCESS = 'POST_FLIPPING_FLYER_SUCCESS',
    POST_FLIPPING_FLYER_ERROR = 'POST_FLIPPING_FLYER_ERROR',
    POST_FLIPPING_FLYER_COMPLETED = 'POST_FLIPPING_FLYER_COMPLETED',
    //crete flyer from pdf
    CREATE_FLYER_FROM_PDF_START = 'CREATE_FLYER_FROM_PDF_START',
    CREATE_FLYER_FROM_PDF_SUCCESS = 'CREATE_FLYER_FROM_PDF_SUCCESS',
    CREATE_FLYER_FROM_PDF_ERROR = 'CREATE_FLYER_FROM_PDF_ERROR',
    CREATE_FLYER_FROM_PDF_COMPLETED = 'CREATE_FLYER_FROM_PDF_COMPLETED',
    //crete flyer from jpegs
    CREATE_FLYER_FROM_JPEGS_START = 'CREATE_FLYER_FROM_JPEGS_START',
    CREATE_FLYER_FROM_JPEGS_SUCCESS = 'CREATE_FLYER_FROM_JPEGS_SUCCESS',
    CREATE_FLYER_FROM_JPEGS_ERROR = 'CREATE_FLYER_FROM_JPEGS_ERROR',
    CREATE_FLYER_FROM_JPEGS_COMPLETED = 'CREATE_FLYER_FROM_JPEGS_COMPLETED',
    //crete flyer from page numbering
    CREATE_FLYER_WITHOUT_PAGE_IMAGES_START = 'CREATE_FLYER_WITHOUT_PAGE_IMAGES_START',
    CREATE_FLYER_WITHOUT_PAGE_IMAGES_SUCCESS = 'CREATE_FLYER_WITHOUT_PAGE_IMAGES_SUCCESS',
    CREATE_FLYER_WITHOUT_PAGE_IMAGES_ERROR = 'CREATE_FLYER_WITHOUT_PAGE_IMAGES_ERROR',
    CREATE_FLYER_WITHOUT_PAGE_IMAGES_COMPLETED = 'CREATE_FLYER_WITHOUT_PAGE_IMAGES_COMPLETED',
    //update flyer/flipbook
    UPDATE_FLIPBOOK_START = 'UPDATE_FLIPBOOK_START',
    UPDATE_FLIPBOOK_SUCCESS = 'UPDATE_FLIPBOOK_SUCCESS',
    UPDATE_FLIPBOOK_ERROR = 'UPDATE_FLIPBOOK_ERROR',
    UPDATE_FLIPBOOK_COMPLETED = 'UPDATE_FLIPBOOK_COMPLETED',

    // spots xls file
    POST_FLYER_SPOTS_START = 'POST_FLYER_SPOTS_START',
    POST_FLYER_SPOTS_SUCCESS = 'POST_FLYER_SPOTS_SUCCESS',
    POST_FLYER_SPOTS_ERROR = 'POST_FLYER_SPOTS_ERROR',
    POST_FLYER_SPOTS_COMPLETED = 'POST_FLYER_SPOTS_COMPLETED',
    // frames get xls file
    GET_CURRENT_DATA_FRAMES_FOR_FLYER_START = 'GET_CURRENT_DATA_FRAMES_FOR_FLYER_START',
    GET_CURRENT_DATA_FRAMES_FOR_FLYER_SUCCESS = 'GET_CURRENT_DATA_FRAMES_FOR_FLYER_SUCCESS',
    GET_CURRENT_DATA_FRAMES_FOR_FLYER_ERROR = 'GET_CURRENT_DATA_FRAMES_FOR_FLYER_ERROR',
    GET_CURRENT_DATA_FRAMES_FOR_FLYER_COMPLETE = 'GET_CURRENT_DATA_FRAMES_FOR_FLYER_COMPLETE',


    // spots create
    POST_FLYER_SPOTS_CREATE_START = 'POST_FLYER_SPOTS_CREATE_START',
    POST_FLYER_SPOTS_CREATE_SUCCESS = 'POST_FLYER_SPOTS_CREATE_SUCCESS',
    POST_FLYER_SPOTS_CREATE_ERROR = 'POST_FLYER_SPOTS_CREATE_ERROR',
    POST_FLYER_SPOTS_CREATE_COMPLETED = 'POST_FLYER_SPOTS_CREATE_COMPLETED',

    // spots update
    POST_FLYER_SPOTS_UPDATE_START = 'POST_FLYER_SPOTS_UPDATE_START',
    POST_FLYER_SPOTS_UPDATE_SUCCESS = 'POST_FLYER_SPOTS_UPDATE_SUCCESS',
    POST_FLYER_SPOTS_UPDATE_ERROR = 'POST_FLYER_SPOTS_UPDATE_ERROR',
    POST_FLYER_SPOTS_UPDATE_COMPLETED = 'POST_FLYER_SPOTS_UPDATE_COMPLETED',

    // spots delete
    POST_FLYER_SPOTS_DELETE_START = 'POST_FLYER_SPOTS_DELETE_START',
    POST_FLYER_SPOTS_DELETE_SUCCESS = 'POST_FLYER_SPOTS_DELETE_SUCCESS',
    POST_FLYER_SPOTS_DELETE_ERROR = 'POST_FLYER_SPOTS_DELETE_ERROR',
    POST_FLYER_SPOTS_DELETE_COMPLETED = 'POST_FLYER_SPOTS_DELETE_COMPLETED',
    //frames orientation numbering
    CHANGE_ORIENTATION_NUMBERING_FOR_FRAMES = 'CHANGE_ORIENTATION_NUMBERING_FOR_FRAMES',
    //frames selectAllMode
    TOGGLE_SELECT_ALL_FRAMES = 'TOGGLE_SELECT_ALL_FRAMES',

    // promos xls file
    POST_FLYER_PROMOS_START = 'POST_FLYER_PROMOS_START',
    POST_FLYER_PROMOS_SUCCESS = 'POST_FLYER_PROMOS_SUCCESS',
    POST_FLYER_PROMOS_ERROR = 'POST_FLYER_PROMOS_ERROR',
    POST_FLYER_PROMOS_COMPLETED = 'POST_FLYER_PROMOS_COMPLETED',
    // promos and items xls file
    POST_FLYER_PROMOS_AND_ITEMS_START = 'POST_FLYER_PROMOS_AND_ITEMS_START',
    POST_FLYER_PROMOS_AND_ITEMS_SUCCESS = 'POST_FLYER_PROMOS_AND_ITEMS_SUCCESS',
    POST_FLYER_PROMOS_AND_ITEMS_ERROR = 'POST_FLYER_PROMOS_AND_ITEMS_ERROR',
    POST_FLYER_PROMOS_AND_ITEMS_COMPLETED = 'POST_FLYER_PROMOS_AND_ITEMS_COMPLETED',

    // get empty promotion and items xls file
    GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_START = 'GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_START',
    GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_SUCCESS = 'GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_SUCCESS',
    GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_ERROR = 'GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_ERROR',
    GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_COMPLETE = 'GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_COMPLETE',
    // get promotions and items data for current flyer xls file
    GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_START = 'GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_START',
    GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_SUCCESS = 'GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_SUCCESS',
    GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_ERROR = 'GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_ERROR',
    GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_COMPLETE = 'GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_COMPLETE',

    // items images items xls file
    POST_IMAGES_FOR_PROMOTIONS_ITEMS_START = 'POST_IMAGES_FOR_PROMOTIONS_ITEMS_START',
    POST_IMAGES_FOR_PROMOTIONS_ITEMS_SUCCESS = 'POST_IMAGES_FOR_PROMOTIONS_ITEMS_SUCCESS',
    POST_IMAGES_FOR_PROMOTIONS_ITEMS_ERROR = 'POST_IMAGES_FOR_PROMOTIONS_ITEMS_ERROR',
    POST_IMAGES_FOR_PROMOTIONS_ITEMS_COMPLETE = 'POST_IMAGES_FOR_PROMOTIONS_ITEMS_COMPLETE',

    // promotion images files
    POST_IMAGES_FOR_PROMOTIONS_START = 'POST_IMAGES_FOR_PROMOTIONS_START',
    POST_IMAGES_FOR_PROMOTIONS_SUCCESS = 'POST_IMAGES_FOR_PROMOTIONS_SUCCESS',
    POST_IMAGES_FOR_PROMOTIONS_ERROR = 'POST_IMAGES_FOR_PROMOTIONS_ERROR',
    POST_IMAGES_FOR_PROMOTIONS_COMPLETE = 'POST_IMAGES_FOR_PROMOTIONS_COMPLETE',

    // items images files
    POST_IMAGES_FOR_ITEMS_START = 'POST_IMAGES_FOR_ITEMS_START',
    POST_IMAGES_FOR_ITEMS_SUCCESS = 'POST_IMAGES_FOR_ITEMS_SUCCESS',
    POST_IMAGES_FOR_ITEMS_ERROR = 'POST_IMAGES_FOR_ITEMS_ERROR',
    POST_IMAGES_FOR_ITEMS_COMPLETE = 'POST_IMAGES_FOR_ITEMS_COMPLETE',

    // promo items xls file
    POST_FLYER_PROMOITEMS_START = 'POST_FLYER_PROMOITEMS_START',
    POST_FLYER_PROMOITEMS_SUCCESS = 'POST_FLYER_PROMOITEMS_SUCCESS',
    POST_FLYER_PROMOITEMS_ERROR = 'POST_FLYER_PROMOITEMS_ERROR',
    POST_FLYER_PROMOITEMS_COMPLETED = 'POST_FLYER_PROMOITEMS_COMPLETED',

    // post image to item jpg file
    POST_IMAGE_TO_ITEM_START = 'POST_IMAGE_TO_ITEM_START',
    POST_IMAGE_TO_ITEM_SUCCESS = 'POST_IMAGE_TO_ITEM_SUCCESS',
    POST_IMAGE_TO_ITEM_ERROR = 'POST_IMAGE_TO_ITEM_ERROR',
    POST_IMAGE_TO_ITEM_COMPLETED = 'POST_IMAGE_TO_ITEM_COMPLETED',
    // change qualification status of items
    CHANGE_QUALIFICATION_LVL_FOR_ITEMS_START = 'CHANGE_QUALIFICATION_LVL_FOR_ITEMS_START',
    CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS = 'CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS',
    CHANGE_QUALIFICATION_LVL_FOR_ITEMS_ERROR = 'CHANGE_QUALIFICATION_LVL_FOR_ITEMS_ERROR',
    CHANGE_QUALIFICATION_LVL_FOR_ITEMS_COMPLETED = 'CHANGE_QUALIFICATION_LVL_FOR_ITEMS_COMPLETED',
    // change qualification status of promos
    CHANGE_QUALIFICATION_LVL_FOR_PROMOS_START = 'CHANGE_QUALIFICATION_LVL_FOR_PROMOS_START',
    CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS = 'CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS',
    CHANGE_QUALIFICATION_LVL_FOR_PROMOS_ERROR = 'CHANGE_QUALIFICATION_LVL_FOR_PROMOS_ERROR',
    CHANGE_QUALIFICATION_LVL_FOR_PROMOS_COMPLETED = 'CHANGE_QUALIFICATION_LVL_FOR_PROMOS_COMPLETED',

    // smart flyer
    GET_SMART_FLYER_START = 'GET_SMART_FLYER_START',
    GET_SMART_FLYER_SUCCESS = 'GET_SMART_FLYER_SUCCESS',
    GET_SMART_FLYER_ERROR = 'GET_SMART_FLYER_ERROR',
    GET_SMART_FLYER_COMPLETED = 'GET_SMART_FLYER_COMPLETED',

    SMART_FLYER_DATA_CHANGE_EVENT = 'SMART_FLYER_DATA_CHANGE_EVENT',

    POST_SMART_FLYER_START = 'POST_SMART_FLYER_START',
    POST_SMART_FLYER_SUCCESS = 'POST_SMART_FLYER_SUCCESS',
    POST_SMART_FLYER_ERROR = 'POST_SMART_FLYER_ERROR',
    POST_SMART_FLYER_COMPLETED = 'POST_SMART_FLYER_COMPLETED',


    // gui settings
    GET_GUI_SETTINGS_START = 'GET_GUI_SETTINGS_START',
    GET_GUI_SETTINGS_SUCCESS = 'GET_GUI_SETTINGS_SUCCESS',
    GET_GUI_SETTINGS_ERROR = 'GET_GUI_SETTINGS_ERROR',
    GET_GUI_SETTINGS_COMPLETED = 'GET_GUI_SETTINGS_COMPLETED',

    PUT_GUI_SETTINGS_START = 'PUT_GUI_SETTINGS_START',
    PUT_GUI_SETTINGS_SUCCESS = 'PUT_GUI_SETTINGS_SUCCESS',
    PUT_GUI_SETTINGS_ERROR = 'PUT_GUI_SETTINGS_ERROR',
    PUT_GUI_SETTINGS_COMPLETED = 'PUT_GUI_SETTINGS_COMPLETED',

    DELETE_GUI_SETTINGS_START = 'DELETE_GUI_SETTINGS_START',
    DELETE_GUI_SETTINGS_SUCCESS = 'DELETE_GUI_SETTINGS_SUCCESS',
    DELETE_GUI_SETTINGS_ERROR = 'DELETE_GUI_SETTINGS_ERROR',
    DELETE_GUI_SETTINGS_COMPLETED = 'DELETE_GUI_SETTINGS_COMPLETED',

    //pages
    DELETE_PAGE = 'DELETE_PAGE',
    DELETE_PAGE_SUCCESS = 'DELETE_PAGE_SUCCESS',
    DELETE_PAGE_ERROR = 'DELETE_PAGE_ERROR',

    DELETE_PAGE_IMAGE = 'DELETE_PAGE_IMAGE',
    DELETE_PAGE_IMAGE_SUCCESS = 'DELETE_PAGE_IMAGE_SUCCESS',
    DELETE_PAGE_IMAGE_ERROR = 'DELETE_PAGE_IMAGE_ERROR',

    INSERT_PAGE = 'INSERT_PAGE',
    INSERT_PAGE_SUCCESS = 'INSERT_PAGE_SUCCESS',
    INSERT_PAGE_ERROR = 'INSERT_PAGE_ERROR',

    MOVE_PAGES_BEFORE = 'MOVE_PAGES_BEFORE',
    MOVE_PAGES_BEFORE_SUCCESS = 'MOVE_PAGES_BEFORE_SUCCESS',
    MOVE_PAGES_BEFORE_ERROR = 'MOVE_PAGES_BEFORE_ERROR',

    UPLOAD_IMAGES_TO_PAGES = 'UPLOAD_IMAGES_TO_PAGES',
    UPLOAD_IMAGES_TO_PAGES_SUCCESS = 'UPLOAD_IMAGES_TO_PAGES_SUCCESS',
    UPLOAD_IMAGES_TO_PAGES_ERROR = 'UPLOAD_IMAGES_TO_PAGES_ERROR',

    CHANGE_QUALIFICATION_STATUS_FOR_PAGES_START = 'CHANGE_QUALIFICATION_STATUS_FOR_PAGES_START',
    CHANGE_QUALIFICATION_STATUS_FOR_PAGES_SUCCESS = 'CHANGE_QUALIFICATION_STATUS_FOR_PAGES_SUCCESS',
    CHANGE_QUALIFICATION_STATUS_FOR_PAGES_ERROR = 'CHANGE_QUALIFICATION_STATUS_FOR_PAGES_ERROR',
    CHANGE_QUALIFICATION_STATUS_FOR_PAGES_COMPLETE = 'CHANGE_QUALIFICATION_STATUS_FOR_PAGES_COMPLETE',

    SET_SELECTED_PAGE_FOR_TABS = 'SET_SELECTED_PAGE_FOR_TABS',

    CHANGE_ACTIVE_TAB_NAME = 'CHANGE_ACTIVE_TAB_NAME',
    CHANGE_SEARCH_TERM = 'CHANGE_SEARCH_TERM',
    SAVE_PROMO_ITEMS_FILE_IN_STATE = 'SAVE_PROMO_ITEMS_FILE_IN_STATE',
    ADD_PROMOS_TO_UNLINK_PROMOS = 'ADD_PROMOS_TO_UNLINK_PROMOS',
    ADD_ITEMS_TO_UNLINK_ITEMS = 'ADD_ITEMS_TO_UNLINK_ITEMS',
    DELETE_PROMOS_FROM_UNLINK_PROMOS = 'DELETE_PROMOS_FROM_UNLINK_PROMOS',
    DELETE_ITEMS_FROM_UNLINK_ITEMS = 'DELETE_ITEMS_FROM_UNLINK_ITEMS',
    CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU = 'CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU',
    TOGGLE_UNLINK_PANEL = 'TOGGLE_UNLINK_PANEL',
    CHANGE_QUALIFIED_STATUS_FOR_PROMOTIONS_AND_ITEMS = "CHANGE_QUALIFIED_STATUS_FOR_PROMOTIONS_AND_ITEMS",
    CHANGE_SELECT_ALL_STATUS_FOR_PROMOTIONS_AND_ITEMS = "CHANGE_SELECT_ALL_STATUS_FOR_PROMOTIONS_AND_ITEMS",


    ATTACH_PROMO_TO_FLYER_START = 'ATTACH_PROMO_TO_FLYER_START',
    ATTACH_PROMO_TO_FLYER_SUCCESS = 'ATTACH_PROMO_TO_FLYER_SUCCESS',
    ATTACH_PROMO_TO_FLYER_ERROR = 'ATTACH_PROMO_TO_FLYER_ERROR',
    ATTACH_PROMO_TO_FLYER_COMPLETE = 'ATTACH_PROMO_TO_FLYER_COMPLETE',

    ATTACH_PROMO_TO_FLYER_DND_SUCCESS = 'ATTACH_PROMO_TO_FLYER_SUCCESS',
    ATTACH_PROMO_TO_FLYER_DND_COMPLETE = 'ATTACH_PROMO_TO_FLYER_COMPLETE',

    ATTACH_ITEMS_TO_FLYER_START = 'ATTACH_ITEMS_TO_FLYER_START',
    ATTACH_ITEMS_TO_FLYER_SUCCESS = 'ATTACH_ITEMS_TO_FLYER_SUCCESS',
    ATTACH_ITEMS_TO_FLYER_ERROR = 'ATTACH_ITEMS_TO_FLYER_ERROR',
    ATTACH_ITEMS_TO_FLYER_COMPLETE = 'ATTACH_ITEMS_TO_FLYER_COMPLETE',


    SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE = 'SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE',
    SET_ITEMS_TO_PROMO_ITEMS_STATE = 'SET_ITEMS_TO_PROMO_ITEMS_STATE',
    ADD_ITEMS_TO_PROMO_ITEMS_STATE = 'ADD_ITEMS_TO_PROMO_ITEMS_STATE',
    REMOVE_ITEMS_TO_PROMO_ITEMS_STATE = 'REMOVE_ITEMS_TO_PROMO_ITEMS_STATE',

    SET_PROMOS_TO_PROMO_ITEMS_STATE = 'SET_PROMOS_TO_PROMO_ITEMS_STATE',


    // ATTACH_ITEMS_TO_FLYER_DND_SUCCESS = 'ATTACH_ITEMS_TO_FLYER_DND_SUCCESS',
    // ATTACH_ITEMS_TO_FLYER_DND_COMPLETE = 'ATTACH_ITEMS_TO_FLYER_DND_COMPLETE',


    ATTACH_PROMO_TO_FRAME_START = 'ATTACH_PROMO_TO_FRAME_START',
    ATTACH_PROMO_TO_FRAME_SUCCESS = 'ATTACH_PROMO_TO_FRAME_SUCCESS',
    ATTACH_PROMO_TO_FRAME_ERROR = 'ATTACH_PROMO_TO_FRAME_ERROR',
    ATTACH_PROMO_TO_FRAME_COMPLETE = 'ATTACH_PROMO_TO_FRAME_COMPLETE',

    ATTACH_PROMO_TO_FRAME_DND_SUCCESS = 'ATTACH_PROMO_TO_FRAME_DND_SUCCESS',
    ATTACH_PROMO_TO_FRAME_DND_COMPLETE = 'ATTACH_PROMO_TO_FRAME_DND_COMPLETE',

    ATTACH_ITEM_TO_PROMO_START = 'ATTACH_ITEM_TO_PROMO_START',
    ATTACH_ITEM_TO_PROMO_SUCCESS = 'ATTACH_ITEM_TO_PROMO_SUCCESS',
    ATTACH_ITEM_TO_PROMO_ERROR = 'ATTACH_ITEM_TO_PROMO_ERROR',
    ATTACH_ITEM_TO_PROMO_COMPLETE = 'ATTACH_ITEM_TO_PROMO_COMPLETE',

    UPDATE_ITEM_START = 'UPDATE_ITEM_START',
    UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS',
    UPDATE_ITEM_ERROR = 'UPDATE_ITEM_ERROR',
    UPDATE_ITEM_COMPLETE = 'UPDATE_ITEM_COMPLETE',

    EDIT_PROMOTION_ITEM_START = 'EDIT_PROMOTION_ITEM_START',
    EDIT_PROMOTION_ITEM_SUCCESS = 'EDIT_PROMOTION_ITEM_SUCCESS',
    EDIT_PROMOTION_ITEM_ERROR = 'EDIT_PROMOTION_ITEM_ERROR',
    EDIT_PROMOTION_ITEM_COMPLETE = 'EDIT_PROMOTION_ITEM_COMPLETE',

    CREATE_PROMOTION_ITEM_START = 'CREATE_PROMOTION_ITEM_START',
    CREATE_PROMOTION_ITEM_SUCCESS = 'CREATE_PROMOTION_ITEM_SUCCESS',
    CREATE_PROMOTION_ITEM_ERROR = 'CREATE_PROMOTION_ITEM_ERROR',
    CREATE_PROMOTION_ITEM_COMPLETE = 'CREATE_PROMOTION_ITEM_COMPLETE',

    CREATE_ITEM_START = 'CREATE_ITEM_START',
    CREATE_ITEM_SUCCESS = 'CREATE_ITEM_SUCCESS',
    CREATE_ITEM_ERROR = 'CREATE_ITEM_ERROR',
    CREATE_ITEM_COMPLETE = 'CREATE_ITEM_COMPLETE',

    UPDATE_PROMOTION_START = 'UPDATE_PROMOTION_START',
    UPDATE_PROMOTION_SUCCESS = 'UPDATE_PROMOTION_SUCCESS',
    UPDATE_PROMOTION_ERROR = 'UPDATE_PROMOTION_ERROR',
    UPDATE_PROMOTION_COMPLETE = 'UPDATE_PROMOTION_COMPLETE',

    CREATE_PROMOTION_START = 'CREATE_PROMOTION_START',
    CREATE_PROMOTION_SUCCESS = 'CREATE_PROMOTION_SUCCESS',
    CREATE_PROMOTION_ERROR = 'CREATE_PROMOTION_ERROR',
    CREATE_PROMOTION_COMPLETE = 'CREATE_PROMOTION_COMPLETE',


    ATTACH_ITEM_TO_PROMO_DND_SUCCESS = 'ATTACH_ITEM_TO_PROMO_DND_SUCCESS',
    ATTACH_ITEM_TO_PROMO_DND_COMPLETE = 'ATTACH_ITEM_TO_PROMO_DND_COMPLETE',

    DELETE_PROMO_FROM_FLYER_START = 'DELETE_PROMO_FROM_FLYER_START',
    DELETE_PROMO_FROM_FLYER_ERROR = 'DELETE_PROMO_FROM_FLYER_ERROR',
    DELETE_PROMO_FROM_FLYER_SUCCESS = 'DELETE_PROMO_FROM_FLYER_SUCCESS',
    DELETE_PROMO_FROM_FLYER_COMPLETE = 'DELETE_PROMO_FROM_FLYER_COMPLETE',

    DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS = 'DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS',
    DELETE_PROMO_WITH_ITEMS_FROM_FLYER_COMPLETE = 'DELETE_PROMO_WITH_ITEMS_FROM_FLYER_COMPLETE',

    DELETE_ITEMS_FROM_FLYER_START = 'DELETE_ITEMS_FROM_FLYER_START',
    DELETE_ITEMS_FROM_FLYER_ERROR = 'DELETE_ITEMS_FROM_FLYER_ERROR',
    DELETE_ITEMS_FROM_FLYER_SUCCESS = 'DELETE_ITEMS_FROM_FLYER_SUCCESS',
    DELETE_ITEMS_FROM_FLYER_COMPLETE = 'DELETE_ITEMS_FROM_FLYER_COMPLETE',

    DELETE_IMAGE_FROM_ITEM_START = 'DELETE_IMAGE_FROM_ITEM_START',
    DELETE_IMAGE_FROM_ITEM_ERROR = 'DELETE_IMAGE_FROM_ITEM_ERROR',
    DELETE_IMAGE_FROM_ITEM_SUCCESS = 'DELETE_IMAGE_FROM_ITEM_SUCCESS',
    DELETE_IMAGE_FROM_ITEM_COMPLETE = 'DELETE_IMAGE_FROM_ITEM_COMPLETE',

    DELETE_IMAGE_FROM_PROMOTION_START = 'DELETE_IMAGE_FROM_PROMOTION_START',
    DELETE_IMAGE_FROM_PROMOTION_SUCCESS = 'DELETE_IMAGE_FROM_PROMOTION_SUCCESS',
    DELETE_IMAGE_FROM_PROMOTION_ERROR = 'DELETE_IMAGE_FROM_PROMOTION_ERROR',
    DELETE_IMAGE_FROM_PROMOTION_COMPLETE = 'DELETE_IMAGE_FROM_PROMOTION_COMPLETE',

    CHANGE_DRAGGING_ITEM_RECID = 'CHANGE_DRAGGING_ITEM_RECID',
    // SHOW_HIDE_ALL_ITEMS_IN_ALL_PROMOTIONS = 'SHOW_HIDE_ALL_ITEMS_IN_ALL_PROMOTIONS',

    EDITOR_TOGGLE_FLYER_DETAILS_POPUP = 'EDITOR_TOGGLE_FLYER_DETAILS_POPUP',
    EDITOR_TOGGLE_FLYER_RIGHT_PANEL = 'EDITOR_TOGGLE_FLYER_RIGHT_PANEL',
    EDITOR_TOGGLE_ZOOM_IN_MODE_FOR_FRAMES_PROMOS_SCREENS = 'EDITOR_TOGGLE_ZOOM_IN_MODE_FOR_FRAMES_PROMOS_SCREENS',

    //filters action types
    CHANGE_FLYERS_VIEW_FILTER = "CHANGE_FLYERS_VIEW_FILTER",
    CHANGE_FLYERS_CLASSES_FILTER = "CHANGE_FLYERS_CLASSES_FILTER",

    SET_ACCOUNT_SETTING_START = 'SET_ACCOUNT_SETTING_START',
    SET_ACCOUNT_SETTING_SUCCESS = 'SET_ACCOUNT_SETTING_SUCCESS',
    SET_ACCOUNT_SETTING_COMPLETE = 'SET_ACCOUNT_SETTING_COMPLETE',
    SET_ACCOUNT_SETTING_ERROR = 'SET_ACCOUNT_SETTING_ERROR',
    SET_ACCOUNT_LANGUAGE_ID = 'SET_ACCOUNT_LANGUAGE_ID',

    GET_ANALYTICS_DATA_FOR_FLYER_START = 'GET_ANALYTICS_DATA_FOR_FLYER_START',
    GET_ANALYTICS_DATA_FOR_FLYER_SUCCESS = 'GET_ANALYTICS_DATA_FOR_FLYER_SUCCESS',
    GET_ANALYTICS_DATA_FOR_FLYER_COMPLETE = 'GET_ANALYTICS_DATA_FOR_FLYER_COMPLETE',
    GET_ANALYTICS_DATA_FOR_FLYER_ERROR = 'GET_ANALYTICS_DATA_FOR_FLYER_ERROR',


    DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_START = 'DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_START',
    DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_SUCCESS = 'DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_SUCCESS',
    DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_ERROR = 'DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_ERROR',
    DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_COMPLETE = 'DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_COMPLETE',

    UPLOAD_IMAGES_PROGRESSBAR_POPUP_START = "UPLOAD_IMAGES_PROGRESSBAR_POPUP_START",
    UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE = "UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE",
    UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE = "UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE",
    UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR = "UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR",

    DOWNLOAD_FILE_START = 'DOWNLOAD_FILE_START',
    DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS',
    DOWNLOAD_FILE_ERROR = 'DOWNLOAD_FILE_ERROR',
    DOWNLOAD_FILE_COMPLETE = 'DOWNLOAD_FILE_COMPLETE',


    CREATE_TOC_FOR_PAGE_START = "CREATE_TOC_FOR_PAGE_START",
    CREATE_TOC_FOR_PAGE_SUCCESS = "CREATE_TOC_FOR_PAGE_SUCCESS",
    CREATE_TOC_FOR_PAGE_ERROR = "CREATE_TOC_FOR_PAGE_ERROR",
    CREATE_TOC_FOR_PAGE_COMPLETE = "CREATE_TOC_FOR_PAGE_COMPLETE",

    UPDATE_TOC_FOR_PAGE_START = "UPDATE_TOC_FOR_PAGE_START",
    UPDATE_TOC_FOR_PAGE_SUCCESS = "UPDATE_TOC_FOR_PAGE_SUCCESS",
    UPDATE_TOC_FOR_PAGE_ERROR = "UPDATE_TOC_FOR_PAGE_ERROR",
    UPDATE_TOC_FOR_PAGE_COMPLETE = "UPDATE_TOC_FOR_PAGE_COMPLETE",

    DELETE_TOC_FOR_PAGE_START = "DELETE_TOC_FOR_PAGE_START",
    DELETE_TOC_FOR_PAGE_SUCCESS = "DELETE_TOC_FOR_PAGE_SUCCESS",
    DELETE_TOC_FOR_PAGE_ERROR = "DELETE_TOC_FOR_PAGE_ERROR",
    DELETE_TOC_FOR_PAGE_COMPLETE = "DELETE_TOC_FOR_PAGE_COMPLETE",

    CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_START = "CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_START",
    CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_SUCCESS = "CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_SUCCESS",
    CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_ERROR = "CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_ERROR",
    CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_COMPLETE = "CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_COMPLETE",

    //flyer classes types
    GET_FLYER_CLASSES_START = "GET_FLYER_CLASSES_START",
    GET_FLYER_CLASSES_SUCCESS = "GET_FLYER_CLASSES_SUCCESS",
    GET_FLYER_CLASSES_ERROR = "GET_FLYER_CLASSES_ERROR",
    GET_FLYER_CLASSES_COMPLETE = "GET_FLYER_CLASSES_COMPLETE",

    CREATE_FLYER_CLASS_START = "CREATE_FLYER_CLASS_START",
    CREATE_FLYER_CLASS_SUCCESS = "CREATE_FLYER_CLASS_SUCCESS",
    CREATE_FLYER_CLASS_ERROR = "CREATE_FLYER_CLASS_ERROR",
    CREATE_FLYER_CLASS_COMPLETE = "CREATE_FLYER_CLASS_COMPLETE",

    UPDATE_FLYER_CLASS_START = "UPDATE_FLYER_CLASS_START",
    UPDATE_FLYER_CLASS_SUCCESS = "UPDATE_FLYER_CLASS_SUCCESS",
    UPDATE_FLYER_CLASS_ERROR = "UPDATE_FLYER_CLASS_ERROR",
    UPDATE_FLYER_CLASS_COMPLETE = "UPDATE_FLYER_CLASS_COMPLETE",

    DELETE_FLYER_CLASS_START = "DELETE_FLYER_CLASS_START",
    DELETE_FLYER_CLASS_SUCCESS = "DELETE_FLYER_CLASS_SUCCESS",
    DELETE_FLYER_CLASS_ERROR = "DELETE_FLYER_CLASS_ERROR",
    DELETE_FLYER_CLASS_COMPLETE = "DELETE_FLYER_CLASS_COMPLETE",

    //emails types
    GET_ACCOUNT_EMAILS_SETTING_START = 'GET_ACCOUNT_EMAILS_SETTING_START',
    GET_ACCOUNT_EMAILS_SETTING_SUCCESS = 'GET_ACCOUNT_EMAILS_SETTING_SUCCESS',
    GET_ACCOUNT_EMAILS_SETTING_COMPLETE = 'GET_ACCOUNT_EMAILS_SETTING_COMPLETE',
    GET_ACCOUNT_EMAILS_SETTING_ERROR = 'GET_ACCOUNT_EMAILS_SETTING_ERROR',

    SET_ACCOUNT_EMAILS_SETTING_START = 'SET_ACCOUNT_EMAILS_SETTING_START',
    SET_ACCOUNT_EMAILS_SETTING_SUCCESS = 'SET_ACCOUNT_EMAILS_SETTING_SUCCESS',
    SET_ACCOUNT_EMAILS_SETTING_COMPLETE = 'SET_ACCOUNT_EMAILS_SETTING_COMPLETE',
    SET_ACCOUNT_EMAILS_SETTING_ERROR = 'SET_ACCOUNT_EMAILS_SETTING_ERROR',

    //store settings types
    GET_ACCOUNT_STORE_SETTINGS_START = 'GET_ACCOUNT_STORE_SETTINGS_START',
    GET_ACCOUNT_STORE_SETTINGS_SUCCESS = 'GET_ACCOUNT_STORE_SETTINGS_SUCCESS',
    GET_ACCOUNT_STORE_SETTINGS_COMPLETE = 'GET_ACCOUNT_STORE_SETTINGS_COMPLETE',
    GET_ACCOUNT_STORE_SETTINGS_ERROR = 'GET_ACCOUNT_STORE_SETTINGS_ERROR',

    DELETE_ACCOUNT_STORE_SETTINGS_START = 'DELETE_ACCOUNT_STORE_SETTINGS_START',
    DELETE_ACCOUNT_STORE_SETTINGS_SUCCESS = 'DELETE_ACCOUNT_STORE_SETTINGS_SUCCESS',
    DELETE_ACCOUNT_STORE_SETTINGS_COMPLETE = 'DELETE_ACCOUNT_STORE_SETTINGS_COMPLETE',
    DELETE_ACCOUNT_STORE_SETTINGS_ERROR = 'DELETE_ACCOUNT_STORE_SETTINGS_ERROR',

    SET_DEFAULT_ACCOUNT_STORE_SETTINGS_START = 'SET_DEFAULT_ACCOUNT_STORE_SETTINGS_START',
    SET_DEFAULT_ACCOUNT_STORE_SETTINGS_SUCCESS = 'SET_DEFAULT_ACCOUNT_STORE_SETTINGS_SUCCESS',
    SET_DEFAULT_ACCOUNT_STORE_SETTINGS_COMPLETE = 'SET_DEFAULT_ACCOUNT_STORE_SETTINGS_COMPLETE',
    SET_DEFAULT_ACCOUNT_STORE_SETTINGS_ERROR = 'SET_DEFAULT_ACCOUNT_STORE_SETTINGS_ERROR',

    SAVE_ACCOUNT_STORE_SETTING_START = 'SAVE_ACCOUNT_STORE_SETTING_START',
    SAVE_ACCOUNT_STORE_SETTING_SUCCESS = 'SAVE_ACCOUNT_STORE_SETTING_SUCCESS',
    SAVE_ACCOUNT_STORE_SETTING_COMPLETE = 'SAVE_ACCOUNT_STORE_SETTING_COMPLETE',
    SAVE_ACCOUNT_STORE_SETTING_ERROR = 'SAVE_ACCOUNT_STORE_SETTING_ERROR',

    //users and permissions types
    GET_USERS_AND_PERMISSIONS_DATA_START = 'GET_USERS_AND_PERMISSIONS_DATA_START',
    GET_USERS_AND_PERMISSIONS_DATA_SUCCESS = 'GET_USERS_AND_PERMISSIONS_DATA_SUCCESS',
    GET_USERS_AND_PERMISSIONS_DATA_COMPLETE = 'GET_USERS_AND_PERMISSIONS_DATA_COMPLETE',
    GET_USERS_AND_PERMISSIONS_DATA_ERROR = 'GET_USERS_AND_PERMISSIONS_DATA_ERROR',

    DELETE_USER_AND_PERMISSIONS_DATA_START = 'DELETE_USER_AND_PERMISSIONS_DATA_START',
    DELETE_USER_AND_PERMISSIONS_DATA_SUCCESS = 'DELETE_USER_AND_PERMISSIONS_DATA_SUCCESS',
    DELETE_USER_AND_PERMISSIONS_DATA_COMPLETE = 'DELETE_USER_AND_PERMISSIONS_DATA_COMPLETE',
    DELETE_USER_AND_PERMISSIONS_DATA_ERROR = 'DELETE_USER_AND_PERMISSIONS_DATA_ERROR',

    SAVE_USER_AND_PERMISSIONS_DATA_START = 'SAVE_USER_AND_PERMISSIONS_DATA_START',
    SAVE_USER_AND_PERMISSIONS_DATA_SUCCESS = 'SAVE_USER_AND_PERMISSIONS_DATA_SUCCESS',
    SAVE_USER_AND_PERMISSIONS_DATA_COMPLETE = 'SAVE_USER_AND_PERMISSIONS_DATA_COMPLETE',
    SAVE_USER_AND_PERMISSIONS_DATA_ERROR = 'SAVE_USER_AND_PERMISSIONS_DATA_ERROR',

    UPDATE_USER_AND_PERMISSIONS_DATA = 'UPDATE_USER_AND_PERMISSIONS_DATA',

    UPDATE_USER_PASSWORD_START = 'UPDATE_USER_PASSWORD_START',
    UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS',
    UPDATE_USER_PASSWORD_COMPLETE = 'UPDATE_USER_PASSWORD_COMPLETE',
    UPDATE_USER_PASSWORD_ERROR = 'UPDATE_USER_PASSWORD_ERROR',


    //store types
    UPLOAD_STORE_ITEMS_EXCEL_FILE_START = 'UPLOAD_STORE_ITEMS_EXCEL_FILE_START',
    UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS = 'UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS',
    UPLOAD_STORE_ITEMS_EXCEL_FILE_COMPLETE = 'UPLOAD_STORE_ITEMS_EXCEL_FILE_COMPLETE',
    UPLOAD_STORE_ITEMS_EXCEL_FILE_ERROR = 'UPLOAD_STORE_ITEMS_EXCEL_FILE_ERROR',
    UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_START = 'UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_START',
    UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_SUCCESS = 'UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_SUCCESS',
    UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_COMPLETE = 'UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_COMPLETE',
    UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_ERROR = 'UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_ERROR',
    DOWNLOAD_STORE_EMPTY_EXCEL_FILE_START = 'DOWNLOAD_STORE_EMPTY_EXCEL_FILE_START',
    DOWNLOAD_STORE_EMPTY_EXCEL_FILE_SUCCESS = 'DOWNLOAD_STORE_EMPTY_EXCEL_FILE_SUCCESS',
    DOWNLOAD_STORE_EMPTY_EXCEL_FILE_COMPLETE = 'DOWNLOAD_STORE_EMPTY_EXCEL_FILE_COMPLETE',
    DOWNLOAD_STORE_EMPTY_EXCEL_FILE_ERROR = 'DOWNLOAD_STORE_EMPTY_EXCEL_FILE_ERROR',
    DELETE_STORE_ITEMS_EXCEL_FILE_START = 'DELETE_STORE_ITEMS_EXCEL_FILE_START',
    DELETE_STORE_ITEMS_EXCEL_FILE_SUCCESS = 'DELETE_STORE_ITEMS_EXCEL_FILE_SUCCESS',
    DELETE_STORE_ITEMS_EXCEL_FILE_COMPLETE = 'DELETE_STORE_ITEMS_EXCEL_FILE_COMPLETE',
    DELETE_STORE_ITEMS_EXCEL_FILE_ERROR = 'DELETE_STORE_ITEMS_EXCEL_FILE_ERROR',
}